(function () {
  function getFocusable(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.glariseTheme?.moneyFormat || '${{amount}}');
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function initHeaderMenu() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const toggle = header.querySelector('[data-menu-toggle]');
    const drawer = header.querySelector('[data-menu-drawer]');
    const close = header.querySelector('[data-menu-close]');
    const overlay = header.querySelector('[data-menu-overlay]');
    if (!toggle || !drawer) return;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    let lastFocused = null;

    const open = () => {
      lastFocused = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.removeAttribute('inert');
      const focusables = getFocusable(drawer);
      if (focusables[0]) focusables[0].focus();
      document.body.classList.add('menu-open');
      document.documentElement.classList.add('menu-open');
    };

    const closeMenu = () => {
      drawer.setAttribute('data-open', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('inert', '');
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    toggle.addEventListener('click', () => {
      if (drawer.getAttribute('data-open') === 'true') closeMenu();
      else open();
    });

    close?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeMenu();
    });
  }

  function initQuantityButtons(scope = document) {
    scope.querySelectorAll('[data-quantity]').forEach((wrap) => {
      const input = wrap.querySelector('input[type="number"]');
      if (!input) return;

      wrap.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const action = button.getAttribute('data-quantity-action');
          const step = Number(input.step || 1);
          const min = Number(input.min || 1);
          const max = Number(input.max || 999);
          const current = Number(input.value || min);
          const next = action === 'decrease' ? current - step : current + step;
          input.value = String(Math.max(min, Math.min(max, next)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initProductSections() {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const variantsNode = section.querySelector('[data-variants-json]');
      const form = section.querySelector('form[data-type="add-to-cart-form"]');
      const variantInput = section.querySelector('[data-variant-id]');
      if (!variantsNode || !form || !variantInput) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (error) {
        return;
      }

      const optionGroups = section.querySelectorAll('[data-option-index]');
      const priceWrap = section.querySelector('[data-price-wrap]');
      const compareWrap = section.querySelector('[data-compare-wrap]');
      const submitButton = form.querySelector('[name="add"]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const mainMedia = section.querySelector('[data-main-media]');

      function selectedOptions() {
        return Array.from(optionGroups).map((group) => {
          const select = group.querySelector('select');
          if (select) return select.value;
          const checked = group.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : '';
        });
      }

      function getVariant() {
        if (optionGroups.length === 0) return variants[0];
        const chosen = selectedOptions();
        return variants.find((variant) =>
          variant.options.every((option, index) => chosen[index] === option)
        );
      }

      function syncVariant() {
        const variant = getVariant();
        if (!variant) return;

        variantInput.value = String(variant.id);
        if (priceWrap) priceWrap.textContent = formatMoney(variant.price);

        if (compareWrap) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareWrap.textContent = formatMoney(variant.compare_at_price);
            compareWrap.hidden = false;
          } else {
            compareWrap.hidden = true;
          }
        }

        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        if (submitButton) {
          submitButton.disabled = !variant.available;
          submitButton.textContent = variant.available ? (submitButton.dataset.addLabel || 'Add to cart') : (submitButton.dataset.soldOutLabel || 'Sold out');
        }

        const shouldUpdateUrl = section.getAttribute('data-update-url') === 'true';
        if (shouldUpdateUrl && window.history && window.location.pathname.includes('/products/')) {
          const next = `${window.location.pathname}?variant=${variant.id}`;
          window.history.replaceState({}, '', next);
        }
      }

      optionGroups.forEach((group) => {
        group.addEventListener('change', syncVariant);
      });

      section.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainMedia) return;
          const src = thumb.getAttribute('data-media-src');
          const alt = thumb.getAttribute('data-media-alt');
          if (src) mainMedia.setAttribute('src', src);
          if (alt) mainMedia.setAttribute('alt', alt);
        });
      });

      syncVariant();
      initQuantityButtons(section);

      section.querySelectorAll('[data-scroll-to-form]').forEach((button) => {
        button.addEventListener('click', () => {
          const scrollTargetSelector = button.getAttribute('data-scroll-target');
          const explicitTarget = scrollTargetSelector ? document.querySelector(scrollTargetSelector) : null;
          const target = explicitTarget || form;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });

          const focusScope = explicitTarget || form;
          const focusEl = focusScope.querySelector('button, input, select, textarea');
          if (focusEl) focusEl.focus({ preventScroll: true });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderMenu();
    initQuantityButtons();
    initProductSections();
  });
})();
